import Avatar from "components/Avatar/Avatar";
import Link from "components/Link";
// original name: SingleAuthor
// used at the bottom of src/components/Article/ArticleContent.tsx
import React, { FC } from "react";
import { AUTHORS } from "data/authors/authors";
import { PostAuthorType } from "data/types/author";
import { getAuthorData } from "api/authors/Authors";

export interface ArticleAuthorProps {
  author?: PostAuthorType;
}

const renderWithLinks = (text: string) => {
  const urlRegex = /(\bhttps?:\/\/[-A-Z0-9+&@#/%?=~_|!:,.;]*[-A-Z0-9+&@#/%=~_|])/gi;
  const parts = text.split(urlRegex);

  return parts.map((part, index) => {
    if (part.match(urlRegex)) {
      return <a key={index} href={part} target="_blank" rel="noopener noreferrer">{part}</a>;
    }
    return part;
  });
};


const ArticleAuthor: FC<ArticleAuthorProps> = ({ author }) => {
  if (author === undefined) {
    author = getAuthorData()[0];
  }
  return (
    <div className="nc-ArticleAuthor flex">
      <Link href={author.href}>
        <Avatar
          imgUrl={author.avatar}
          userName={author.displayName}
          sizeClass="h-12 w-12 text-lg sm:text-xl sm:h-24 sm:w-24"
        />
      </Link>
      <div className="flex flex-col ml-3 max-w-lg sm:ml-5">
        <span className="text-xs text-neutral-400 uppercase tracking-wider">
          WRITTEN BY
        </span>
        <h2 className="text-lg font-semibold text-neutral-900 dark:text-neutral-200">
          <Link href={author.href}>{author.displayName}</Link>
        </h2>
        <span className="block mt-1 text-sm text-neutral-500 sm:text-base dark:text-neutral-300">
          {author.desc.split("\n").map((line, index) => (
            <div key={index} className="line">
              {renderWithLinks(line)}
            </div>
          ))}
        </span>
      </div>
    </div>
  );
};

export default ArticleAuthor;
